export default __webpack_public_path__ + "static/media/author-icon.55a3e18b.svg";